export default "__VITE_ASSET__c3f38c7b__"